import { Box, Step as ChakraStep, StepDescription, StepIndicator, StepSeparator, StepStatus, StepTitle } from "@chakra-ui/react"
import { Icon } from "components"

export default function Step({ title, description, icon, ...props }){
    return(
    <ChakraStep {...props}>
        <StepIndicator>
            <StepStatus complete={<Icon name="check" />} incomplete={<Icon name={icon} />} active={<Icon name={icon} />} />
        </StepIndicator>
        <Box>
            { title && <StepTitle children={title} /> }
            { description && <StepDescription children={description} /> }
        </Box>
        <StepSeparator />
    </ChakraStep>
    )
}